const staticsHoc = require('hoist-non-react-statics')

/**
 * @type {import('next-translate').I18nConfig}
 */
module.exports.i18nConfig = {
  logger: () => {},
  locales: ['en'],
  defaultLocale: 'en',
  localeDetection: true,
  loadLocaleFrom: (lang, ns) => {
    switch (ns) {
      case 'common':
        return import(`@features/common.locales/${lang}/index.ts`).then((m) => {
          return m.default
        })
      case 'faucet':
        return import(`@features/faucet.locales/${lang}/index.ts`).then((m) => {
          return m.default
        })
    }
  },
  pages: {
    '*': (props) => {
      const namespaces = ['common']

      if (props.pathname.startsWith('/(faucet)')) {
        namespaces.push('faucet')
      }

      return namespaces
    },
  },
  staticsHoc,
}
